import { createRouter, createWebHistory } from "vue-router";
import About from "../views/About.vue";
import EventList from "../views/EventList.vue";
import EventDetails from "../views/EventDetails.vue";
// import NotFoundComponent from "@/components/NotFoundComponent";

// eslint-disable-next-line no-unused-vars
const routes = [
  {
    path: "/",
    name: "EventList",
    component: EventList
  },
  {
    path: "/about",
    name: "About",
    component: About
  },
  {
    path: "/event/:id",
    name: "EventDetails",
    props: true,
    component: EventDetails
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

export default router;
